export default __webpack_public_path__ + "static/media/disabled-left.b2fa0572.svg";